import axios from '../../axios';

// @MX:ANCHOR: 홈페이지 에디터 API 레이어
// @MX:REASON: Vuex store 액션, 섹션 편집기, 페이지 편집기에서 공통으로 호출 (fan_in >= 3)
export const HomepageApi = {
  // === 콘텐츠 (메인 페이지 섹션) ===

  // 전체 섹션 목록 조회
  getContents: async () => await axios.get('/homepage/admin/contents'),
  // 특정 섹션 조회
  getContent: async (sectionKey) => await axios.get(`/homepage/admin/contents/${sectionKey}`),
  // 특정 섹션 저장 (upsert)
  upsertContent: async (sectionKey, data) => await axios.put(`/homepage/admin/contents/${sectionKey}`, data),
  // 전체 섹션 일괄 저장
  bulkSaveContents: async (data) => await axios.put('/homepage/admin/contents', data),
  // 특정 섹션 삭제
  deleteContent: async (sectionKey) => await axios.delete(`/homepage/admin/contents/${sectionKey}`),

  // === 요금제 ===

  // 요금제 목록 조회
  getPricingPlans: async (params = {}) => await axios.get('/homepage/admin/pricing-plans', { params }),
  // 요금제 단건 조회
  getPricingPlan: async (id) => await axios.get(`/homepage/admin/pricing-plans/${id}`),
  // 요금제 생성
  createPricingPlan: async (data) => await axios.post('/homepage/admin/pricing-plans', data),
  // 요금제 수정
  updatePricingPlan: async (id, data) => await axios.put(`/homepage/admin/pricing-plans/${id}`, data),
  // 요금제 삭제
  deletePricingPlan: async (id) => await axios.delete(`/homepage/admin/pricing-plans/${id}`),
  // 요금제 순서 변경
  reorderPricingPlan: async (id, data) => await axios.patch(`/homepage/admin/pricing-plans/${id}/reorder`, data),

  // === 서비스 페이지 ===

  // 서비스 페이지 목록 조회
  getServicePages: async () => await axios.get('/homepage/admin/services'),
  // 서비스 페이지 단건 조회
  getServicePage: async (slug) => await axios.get(`/homepage/admin/services/${slug}`),
  // 서비스 페이지 저장 (upsert)
  upsertServicePage: async (data) => await axios.put('/homepage/admin/services', data),
  // 서비스 페이지 삭제
  deleteServicePage: async (slug) => await axios.delete(`/homepage/admin/services/${slug}`),

  // === 보도자료 ===

  // 보도자료 목록 조회
  getPressArticles: async (params = {}) => await axios.get('/homepage/admin/press-articles', { params }),
  // 보도자료 단건 조회
  getPressArticle: async (id) => await axios.get(`/homepage/admin/press-articles/${id}`),
  // 보도자료 생성
  createPressArticle: async (data) => await axios.post('/homepage/admin/press-articles', data),
  // 보도자료 수정
  updatePressArticle: async (id, data) => await axios.put(`/homepage/admin/press-articles/${id}`, data),
  // 보도자료 삭제
  deletePressArticle: async (id) => await axios.delete(`/homepage/admin/press-articles/${id}`),
  // 보도자료 순서 변경
  reorderPressArticle: async (id, data) => await axios.patch(`/homepage/admin/press-articles/${id}/reorder`, data),

  // === 다운로드 앱 ===

  // 다운로드 앱 목록 조회
  getDownloadApps: async (params = {}) => await axios.get('/homepage/admin/download-apps', { params }),
  // 다운로드 앱 단건 조회
  getDownloadApp: async (id) => await axios.get(`/homepage/admin/download-apps/${id}`),
  // 다운로드 앱 생성
  createDownloadApp: async (data) => await axios.post('/homepage/admin/download-apps', data),
  // 다운로드 앱 수정
  updateDownloadApp: async (id, data) => await axios.put(`/homepage/admin/download-apps/${id}`, data),
  // 다운로드 앱 삭제
  deleteDownloadApp: async (id) => await axios.delete(`/homepage/admin/download-apps/${id}`),
  // 다운로드 앱 순서 변경
  reorderDownloadApp: async (id, data) => await axios.patch(`/homepage/admin/download-apps/${id}/reorder`, data),

  // === 이미지 업로드 ===

  // 홈페이지 content/stats Redis 캐시 초기화
  invalidateHomepageCache: async () => await axios.post('/homepage/admin/cache/invalidate'),

  // 이미지 파일 업로드 (multipart/form-data)
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post('/homepage/admin/upload-image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '이미지 업로드 중 오류가 발생했습니다.';
      throw new Error(errorMessage);
    }
  },
};
